export default "__VITE_ASSET__CszT8pyQ__"